/**
 * Created by Bear on 17/10/11
 * SDK数据配置文件
 * 用于常用活动数据配置、运营数据配置
 * SDK环境初始化后会挂在_SDKApp['conf']对象
 * modified by dw_liyihang 添加300004文案
 */
// 录入数据
window._SDKCommonConf = {
  // 游戏标示appid
  gameAppID: {
    GJOL: {
      appId: '5549',
      gameName: '古剑奇谭ol'
    },
    GJQT: {
      appId: '5549',
      gameName: '古剑奇谭ol'
    },
    TYL: {
      appId: '5538',
      gameName: '天衍录'
    },
    FY: {
      appId: '5550',
      gameName: '新风云'
    },
    LY: {
      appId: '5121',
      gameName: '灵域'
    },
    THYJ2: {
      appId: '5933',
      gameName: '桃花源记'
    }
  },
  // 盒子游戏(迅雷客户端采用盒子游戏方式打开)
  gameBoxList: ['102011619', '117071523', '116061007', '108221440'],
  xlAppId: '596af11482f747c2a72ac8463b2f8000',
  // 与迅雷侧产品确认当前游戏的bizid，左侧为游戏id，右侧为对应的bizid
  gamesBizidList: {
    default: '1299011661',
    '109261804': '1202003092',
    '105131101': '1202003315',
    '107091817': '1202003638',
    '105151620': '1202023593',
    '113081617': '1202005534',
    '118081804': '1202005690',
    '118111640': '1202005712',
    '109091924': '1202001361',
    '108041434': '1202005841',
    '115051635': '1202005988',
    '101091716': '1202006256',
    '118111407': '1202006262',
    '111091628': '1202006265',
    '103181411': '1202006270',
    '120131411': '1202006556',
    '116191513': '1202006953',
    '104181438': '1199000370',
    '113271627': '1199007780',
    '116192038': '1201006258',
    '113281515': '1202000436',
    '101141630': '1202000598',
    '102171622': '1202000599',
    '117291752': '1202000693',
    '118121045': '1299004446',
    '119121100': '1202004406',
    '118181046': '1202011395',
    '106151740': '1199004960',
    '111161636': '1202016596',
    '120291547': '1201000439',
    '120091419': '1202023593',
    '115051735': '1202010923',
    '102011619': '1202011331',
    '112131714': '1202011090',
    '117071523': '1201004456',
    '111251719': '1199004513',
    '110301735': '1199020206',
    '112091715': '1202010888',
    '117161531': '1299011661',
    '119241005': '1202022110',
    '102291347': '1202020893',
    '117271338': '1199017881',
    '116061007': '1202021553',
    '119291514': '1202019105',
    '104261351': '1202019301',
    '104291206': '1202012615',
    '102201427': '1202023670',
    '115221138': '1202015107',
    '115011442': '1202017321',
    '118281024': '1199020214',
    '114081626': '1202024722',
    '117271126': '1202002875',
    '110021750': '1202005655',
    '120021726': '1202013074',
    '108221440': '1199004138',
    '113201656': '1201024548',
    '112261402': '1202009132',
    '102161112': '1202008004',
    '114191432': '1299024715',
    '111091133': '1202011187',
    '106141127': '1202023593',
    '116201540': '1202023474',
    '113101622': '1202019470',
    '120240942': '1202016402'
  }
}
